import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

$(document).ready(() => {
  if($('.floorplan-hero').length) {
    var slider = tns({
      container: '.floorplan-hero',
      loop: true,
      items: 1,
      nav: true,
      navPosition: "bottom",
      autoplay: true,
      // center: true,
      speed: 1000,
      controlsContainer: ".floorplan-controls",
      autoplayButtonOutput: false
    });

    // document.querySelector('.floorplan-controls').setAttribute('tabindex', -1);
    let tns_buttons = document.querySelectorAll('.tns-nav button');
    tns_buttons.forEach(function(button){
      button.setAttribute('tabindex', 0);
    });
    
  	document.querySelector('[data-controls="prev"]').setAttribute('tabindex', 0);
	  document.querySelector('[data-controls="next"]').setAttribute('tabindex', 0);

    slider.events.on('transitionEnd', function(){
      let tns_buttons = document.querySelectorAll('.tns-nav button');
      tns_buttons.forEach(function(button){
        button.setAttribute('tabindex', 0);
      });
    });
  }
});
